import apolloClient from 'api/apolloClient';
import {
  DOES_ENROLLMENT_HAVE_CENSUS,
  DOES_GROUP_HAVE_CENSUS,
  DOWNLOAD_PREPOPULATED_CENSUS_URLS,
  GET_CENSUS_DOWNLOAD_URLS,
  GET_GROUP_CENSUS_DOWNLOAD_URLS,
  PROCESS_CENSUS,
  PROCESS_GROUP_CENSUS,
  SUBMIT_CENSUS,
  SUBMIT_GROUP_CENSUS,
} from 'api/queries/censusService';
import { CensusFamiliesTable, ExistingCensusInfo } from 'types/censusService';

export async function processCensus(groupId: string, periodId: string): Promise<CensusFamiliesTable> {
  return (
    await apolloClient.query<{ processCensus: CensusFamiliesTable }>({
      query: PROCESS_CENSUS,
      fetchPolicy: 'no-cache',
      variables: { groupId, periodId },
    })
  ).data.processCensus;
}

export async function processGroupCensus(groupId: string): Promise<CensusFamiliesTable> {
  return (
    await apolloClient.query<{ processGroupCensus: CensusFamiliesTable }>({
      query: PROCESS_GROUP_CENSUS,
      fetchPolicy: 'no-cache',
      variables: { groupId },
    })
  ).data.processGroupCensus;
}

export async function doesEnrollmentHaveCensus(groupId: string, periodId: string): Promise<ExistingCensusInfo> {
  return (
    await apolloClient.query<{ doesEnrollmentHaveCensus: ExistingCensusInfo }>({
      query: DOES_ENROLLMENT_HAVE_CENSUS,
      fetchPolicy: 'no-cache',
      variables: { groupId, periodId },
    })
  ).data.doesEnrollmentHaveCensus;
}

export async function doesGroupHaveCensus(groupId: string): Promise<ExistingCensusInfo> {
  return (
    await apolloClient.query<{ doesGroupHaveCensus: ExistingCensusInfo }>({
      query: DOES_GROUP_HAVE_CENSUS,
      fetchPolicy: 'no-cache',
      variables: { groupId },
    })
  ).data.doesGroupHaveCensus;
}

export async function getCensusDownloadUrls(groupId: string, periodId: string): Promise<string[]> {
  return (
    await apolloClient.query<{ getCensusDownloadUrls: string[] }>({
      query: GET_CENSUS_DOWNLOAD_URLS,
      fetchPolicy: 'no-cache',
      variables: { groupId, periodId },
    })
  ).data.getCensusDownloadUrls;
}

export async function getGroupCensusDownloadUrls(groupId: string): Promise<string[]> {
  return (
    await apolloClient.query<{ getGroupCensusDownloadUrls: string[] }>({
      query: GET_GROUP_CENSUS_DOWNLOAD_URLS,
      fetchPolicy: 'no-cache',
      variables: { groupId },
    })
  ).data.getGroupCensusDownloadUrls;
}

export async function getPrepopulatedCensusDownloadUrl(groupId: string, periodId: string): Promise<string> {
  return (
    await apolloClient.query<{ getPrepopulatedCensusDownloadUrl: string }>({
      query: DOWNLOAD_PREPOPULATED_CENSUS_URLS,
      fetchPolicy: 'no-cache',
      variables: { groupId, periodId },
    })
  ).data.getPrepopulatedCensusDownloadUrl;
}

export async function submitCensus(groupId: string, periodId: string): Promise<void> {
  await apolloClient.mutate({
    mutation: SUBMIT_CENSUS,
    fetchPolicy: 'no-cache',
    variables: { groupId, periodId },
  });
}

export async function submitGroupCensus(groupId: string): Promise<void> {
  await apolloClient.mutate({
    mutation: SUBMIT_GROUP_CENSUS,
    fetchPolicy: 'no-cache',
    variables: { groupId },
  });
}
